import React, { ReactElement } from 'react'
import { Formik } from 'formik'

import { RecipientForm } from '@mindfulchefuk/features/GiftCards/components/RecipientForm'
import {
  IRecipientFormContainer,
  RecipientFormState,
} from '@mindfulchefuk/features/GiftCards/interfaces'
import { giftCardRecipientSchema } from '@mindfulchefuk/features/GiftCards/validation'
import { useGiftCardRecipientSubmit } from '@mindfulchefuk/features/GiftCards/hooks/useGiftCardRecipientSubmit'

export const RecipientFormContainer = ({
  amount,
  recipientFirstName,
  recipientLastName,
  recipientEmail,
  recipientEmailConfirm,
  personalMessage,
  sendGiftCardToRecipient,
  onSubmit,
}: IRecipientFormContainer): ReactElement => {
  const handleSubmit = useGiftCardRecipientSubmit(onSubmit)
  return (
    <Formik
      enableReinitialize
      onSubmit={handleSubmit}
      validationSchema={giftCardRecipientSchema}
      initialValues={
        {
          amount,
          recipientFirstName,
          recipientLastName,
          recipientEmail,
          recipientEmailConfirm,
          personalMessage,
          sendGiftCardToRecipient,
        } as RecipientFormState
      }
    >
      <RecipientForm />
    </Formik>
  )
}
